// Arabic operations-views strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enOpsview } from './en-opsview.ts';
import type { Message } from './types.ts';

export const arOpsview: { readonly [K in keyof typeof enOpsview]: Message } = {
  // ---------------------------------------------------------------- integration health (PB-19-08)
  'opv.health.title': 'الأجهزة والتكاملات',
  'opv.health.sub': 'أعداد حسب الحالة ضمن نطاقك. الاتصال ونتيجة العمل حقيقتان منفصلتان: قد يكون الجهاز متصلاً ونتيجته مجهولة أو فاشلة.',
  'opv.health.devices': 'اتصال الأجهزة',
  'opv.health.devicesSub': 'الأجهزة المقترنة والأكشاك، حسب آخر نبضة مقارنة بمهلة كل جهاز.',
  'opv.health.heartbeat': 'آخر نبضة',
  'opv.health.lastJob': 'آخر مهمة للجهاز',
  'opv.health.connectors': 'الموصلات',
  'opv.health.connectorsSub': 'حالة النقل ونتائج العمل للموصلات المفعّلة.',
  'opv.health.transport': 'النقل',
  'opv.health.business': 'نتائج العمل',
  'opv.health.edge': 'وكلاء الحافة',
  'opv.health.poll': 'استطلاع أحداث الدخول',
  'opv.health.pollSub': 'آخر استطلاع لكل موصل دخول نشط. "مجهول" يعني أن المزوّد لم يرد، ولم يُفترض شيء.',
  'opv.health.kind': 'النوع',
  'opv.health.total': 'الإجمالي',
  'opv.health.empty': 'لا توجد أجهزة أو موصلات ضمن هذا النطاق.',
  'opv.conn.connected': 'متصل',
  'opv.conn.degraded': 'متدهور',
  'opv.conn.disconnected': 'لم يُسمع منه',
  'opv.conn.never_connected': 'لم يتصل قط',
  'opv.conn.pending': 'لم يُقترن بعد',
  'opv.kind.printer': 'طابعات البطاقات',
  'opv.kind.scanner': 'الماسحات',
  'opv.kind.reader': 'القارئات',
  'opv.kind.encoder': 'مشفّرات البطاقات',
  'opv.kind.edge_agent': 'وكلاء الحافة',
  'opv.kind.kiosk': 'الأكشاك',
  'opv.age.under_1m': 'أقل من دقيقة',
  'opv.age.1m_to_5m': 'من 1 إلى 5 دقائق',
  'opv.age.5m_to_15m': 'من 5 إلى 15 دقيقة',
  'opv.age.15m_to_1h': 'من 15 إلى 60 دقيقة',
  'opv.age.over_1h': 'أكثر من ساعة',
  'opv.age.never': 'أبداً',
  'opv.job.completed': 'مكتملة',
  'opv.job.failed': 'فاشلة',
  'opv.job.unknown': 'مجهولة — تحقق من الجهاز',
  'opv.job.none': 'لا توجد مهمة بعد',
  'opv.status.draft': 'مسودة',
  'opv.status.enabled': 'مفعّل',
  'opv.status.disabled': 'معطّل',
  'opv.biz.confirmed': 'مؤكدة',
  'opv.biz.attention': 'فشلت خلال آخر 24 ساعة',
  'opv.biz.unknown': 'نتيجة مجهولة تحتاج إلى تسوية',
  'opv.biz.none': 'لا نتائج بعد',
  'opv.edge.enrolled': 'مسجّل ونشط',
  'opv.edge.buffer_dropped': 'أسقط أحداثاً مخزّنة',
  'opv.edge.commands_unknown': 'لديه أوامر نتيجتها مجهولة',
  'opv.edge.commands_pending': 'لديه أوامر بانتظار التنفيذ',
  'opv.edge.bufferedEvents': 'أحداث مخزّنة لدى الوكلاء',
  'opv.poll.ok': 'نجح',
  'opv.poll.unknown': 'مجهول (لا رد)',
  'opv.poll.failed': 'فشل',

  // ---------------------------------------------------------------- recovery evidence (PB-19-06)
  'opv.runs.evidence': 'دليل الاستعادة',
  'opv.runs.backupVerified': 'جرى التدرّب على استعادتها',
  'opv.runs.backupUnverified': 'غير مُتحقق — لا استعادة ناجحة لهذه النسخة',
  'opv.runs.restoreVerified': 'الاستعادة مُتحقق منها',
  'opv.runs.restoreFailed': 'الاستعادة غير مُتحقق منها',
  'opv.runs.notApplicable': 'لا ينطبق',
  'opv.runs.note': 'النسخة الاحتياطية الناجحة ليست دليلاً على إمكانية الاستعادة حتى يُتدرّب على استعادة النسخة نفسها ويُتحقق منها.',

  // ---------------------------------------------------------------- visit access events (PB-11-08)
  'opv.visitEvents.title': 'أحداث الدخول',
  'opv.visitEvents.sub': 'أحداث الأبواب والمناطق التي أبلغ عنها نظام التحكم في الدخول لهذه الزيارة، حسب وقت حدوثها. هي حقائق من المزوّد ولا تغيّر حالة الحضور.',

  // ---------------------------------------------------------------- configuration promotion (PB-19-09)
  'opv.promo.link': 'ترحيل الإعدادات',
  'opv.promo.title': 'ترحيل الإعدادات',
  'opv.promo.intro': 'صدّر الإعدادات القابلة للنقل لهذه المؤسسة، أو افحص حزمة من بيئة أخرى واطّلع على ما ستغيّره هنا. لا يُطبَّق شيء من هذه الصفحة.',
  'opv.promo.facts': 'هذه البيئة',
  'opv.promo.environment': 'البيئة',
  'opv.promo.schema': 'إصدار المخطط',
  'opv.promo.format': 'صيغة الحزمة',
  'opv.promo.signing': 'مفتاح التوقيع',
  'opv.promo.signingNone': 'غير مُعدّ — تُصدَّر الحزم دون توقيع ولا يمكن التحقق من الحزم الموقّعة هنا',
  'opv.promo.apply': 'تطبيق حزمة',
  'opv.promo.applyNone': 'غير متاح هنا. أجرِ التغييرات بعد مراجعتها عبر شاشات الإدارة المعتادة؛ التطبيق والتراجع الآليان بانتظار قرار المالك.',
  'opv.promo.export': 'تصدير',
  'opv.promo.exportSub': 'المواقع والمواقع الفرعية ذات الرموز وسياسات الزوار المنشورة وحدود سياسة الأمان وألوان الهوية. لا حسابات ولا أشخاص ولا بيانات اتصال ولا ملفات ولا أسرار. يُسجَّل كل تصدير في سجل التدقيق.',
  'opv.promo.exportButton': 'تصدير الحزمة',
  'opv.promo.download': 'تنزيل ملف الحزمة',
  'opv.promo.check': 'فحص حزمة',
  'opv.promo.checkSub': 'اختر ملف حزمة. يُتحقق منه (الصيغة والمجموع الاختباري والتوقيع والمحتوى القابل للنقل) ويُخطَّط له مقابل هذه المؤسسة كتشغيل تجريبي.',
  'opv.promo.file': 'ملف الحزمة',
  'opv.promo.fileInvalid': 'هذا الملف ليس JSON صالحاً.',
  'opv.promo.allowUnsigned': 'مراجعة حزمة غير موقّعة (تشغيل تجريبي فقط)',
  'opv.promo.mapping': 'مطابقة المراجع (اختياري)',
  'opv.promo.mappingHint': 'JSON يتضمن "sites" و"locations" (مرجع الحزمة ← مرجع هذه البيئة) و"acceptSecurityLevelChange" (مراجع الحزمة التي قد يختلف مستوى أمانها). رموز فقط.',
  'opv.promo.mappingInvalid': 'يجب أن تكون المطابقة كائن JSON.',
  'opv.promo.validate': 'تحقق',
  'opv.promo.plan': 'خطة (تشغيل تجريبي)',
  'opv.promo.summary': 'الحزمة',
  'opv.promo.source': 'البيئة المصدر',
  'opv.promo.created': 'تاريخ التصدير',
  'opv.promo.organisation': 'المؤسسة المصدر',
  'opv.promo.digest': 'المجموع الاختباري',
  'opv.promo.signed': 'موقّعة بالمفتاح {keyId}',
  'opv.promo.unsigned': 'غير موقّعة',
  'opv.promo.unsignedAccepted': 'قُبلت الحزمة غير الموقّعة للمراجعة فقط.',
  'opv.promo.counts': '{sites} مواقع · {locations} مواقع فرعية ({restricted} مقيّدة) · {policies} سياسات زوار · {branding} إعدادات هوية',
  'opv.promo.skipped': 'غير مضمّن',
  'opv.promo.valid': 'صالحة',
  'opv.promo.invalid': 'غير صالحة',
  'opv.promo.problems': 'المشكلات',
  'opv.promo.planOk': 'لا عوائق',
  'opv.promo.planBlocked': 'معاقة',
  'opv.promo.blockers': 'العوائق',
  'opv.promo.blockersHint': 'عالج كل عائق بمطابقة المرجع مع موقع آخر أو بتسجيل قبول صريح في المطابقة.',
  'opv.promo.items': 'ما الذي سيتغيّر',
  'opv.promo.col.kind': 'النوع',
  'opv.promo.col.ref': 'المرجع هنا',
  'opv.promo.col.action': 'التغيير',
  'opv.promo.col.changes': 'التفاصيل',
  'opv.promo.kind.site': 'موقع',
  'opv.promo.kind.location': 'موقع فرعي',
  'opv.promo.kind.visitor-policy': 'سياسة زوار',
  'opv.promo.kind.security-policy': 'سياسة أمان',
  'opv.promo.kind.branding': 'الهوية',
  'opv.promo.action.create': 'إنشاء',
  'opv.promo.action.update': 'تحديث',
  'opv.promo.action.unchanged': 'دون تغيير',
  'specialist.configuration-promoter': 'مسؤول ترحيل الإعدادات (تصدير حزم الإعدادات والتحقق منها والتخطيط لها)',
};
